import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { OnboardingNavComponent } from './onboarding-nav/onboarding-nav.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MarkdownModule } from 'ngx-markdown';
import { UiComponentsModule } from 'src/app/ui-components/ui-components.module';
import { MaterialModule } from 'src/app/material-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OnboardingWsComponent } from './onboarding-ws/onboarding-ws.component';

@NgModule({
  declarations: [OnboardingComponent, OnboardingNavComponent, OnboardingWsComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    MarkdownModule.forRoot({ loader: HttpClient }),
    UiComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
  ]
})
export class OnboardingModule { }
